import axios from 'axios';
import { forwardHeaders } from '@zmyle/webkit-http-utils';

import { ServerConfig } from 'server/services/serverConfig';
import { getHostname } from 'server/utils/helpers';
import { AppHeaders } from 'utils/constants';
import { isServer } from 'utils/helpers';

const baseURL = '/g/api';

export const clientApi = axios.create({ baseURL, withCredentials: true });

clientApi.interceptors.request.use(async request => {
  if (!isServer()) {
    request.headers[AppHeaders.BROWSER_URL] = window.location.href;

    return request;
  }

  // forward the client request origin/headers to next api
  const { headers } = await import('next/headers');

  const headersInstance = await headers();

  const hostname = getHostname(headersInstance);

  const serverConfig = ServerConfig.getInstance().getConfig();

  const rootUrl =
    serverConfig.dev.networkHostname === hostname
      ? 'http://localhost:3000'
      : hostname;

  request.baseURL = `${rootUrl}${baseURL}`;

  const forwardedHeaders = forwardHeaders(headersInstance);

  forwardedHeaders.forEach((value, key) => {
    request.headers[key] = value;
  });

  const requestedUrl = headersInstance.get(AppHeaders.REQUESTED_URL);

  if (requestedUrl) request.headers[AppHeaders.BROWSER_URL] = requestedUrl;

  return request;
});
